// IMPORTANT this float is margined for the sidebar

import { Box, Fade, Stack } from "@mui/material";
import { FontStyle, sidebarWidth } from "../constants";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";

export const FloatTitle = ({ label }) => {
  return (
    <Box
      sx={{
        ...FontStyle.body,
        position: "absolute",
        left: "8px",
        top: "8px",
        // width: "25px",
        // height: "25px",
        color: "#666",
        // transition: "color 0.2s",
        zIndex: 100,
        letterSpacing: "1px",
        fontSize: "18px",
        textTransform: "uppercase",
        userSelect: "none",
        // "&:hover": {
        //   color: "#000",
        // },
      }}>
      {label}
    </Box>
  );
};

export const CloseButton = ({ ...props }) => {
  return (
    <CloseIcon
      sx={{
        position: "absolute",
        right: "40px",
        top: "40px",
        cursor: "pointer",
        width: "25px",
        height: "25px",
        color: "#666",
        transition: "color 0.2s",
        zIndex: 100,
        "&:hover": {
          color: "#000",
        },
      }}
      {...props}
    />
  );
};
const FloatWrapper = ({ onClick = null, children }) => {
  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      onClick={onClick}
      sx={{
        position: "fixed",
        top: "0px",
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(200,200,210,0.4)",
        zIndex: 100,
        cursor: "initial",
      }}>
      {children}
    </Stack>
  );
};

export const FadeFloatWrapper = ({ show, onClick = null, children }) => {
  return (
    <Fade in={show} mountOnEnter unmountOnExit>
      <Box>
        <FloatWrapper onClick={onClick}>{children}</FloatWrapper>
      </Box>
    </Fade>
  );
};

export default FloatWrapper;
